import { ReactElement } from "react";
import { Navigate, RouteObject } from "react-router-dom";
import { Route } from "../../models/routing.model";
import { getLocalStorageUser, validCookieToken } from "../session/auth.service";

/**
 * Format route data
 * @description Formats the route data, taking into account if the route is nested by the ProtectedRoute
 */
export const getRoute = (route: RouteObject): Route | undefined => {
	const routeElement: React.ReactNode = route?.element as ReactElement;
	let item: Route | undefined;

	if (routeElement?.props?.children) {
		// Has nested route (uses ProtectedRoute)
		item = {
			route: {
				path: route.path,
				element: routeElement.props.children,
			},
			routeProps: routeElement.props.children.props,
		};
	} else if (!routeElement?.props?.children) {
		// Doesn't have nested routes
		item = { route: route, routeProps: routeElement?.props };
	}

	return item;
};

/**
 * Routes: protected
 * @description Protect routes so that they are not accessible when the user is not logged in
 */

export const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
	// Verify authentication
	if (!validCookieToken() || !getLocalStorageUser())
		return (
			<Navigate
				to="/login"
				replace
			/>
		);

	return children;
};
